// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WgkK","largestCol":"styles_largestCol__Ko2Ni","smallestCol":"styles_smallestCol__2mbg1"};